import React from "react";
import { Button, Text, makeStyles, tokens } from "@fluentui/react-components";
import {
  ChevronLeft16Regular,
  ChevronRight16Regular,
  ChevronDoubleLeft16Regular,
  ChevronDoubleRight16Regular,
} from "@fluentui/react-icons";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0",
    flexWrap: "wrap",
    gap: "8px",
  },

  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  pageText: {
    fontSize: "12px",
    color: tokens.colorNeutralForeground2,
  },

  select: {
    padding: "4px 8px",
    borderRadius: tokens.borderRadiusSmall,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    background: tokens.colorNeutralBackground1,
    cursor: "pointer",
  },
});

export default function TablePagination({
  table,
  totalCount = 0,
  pagination,
  setPagination,
  pageSizeOptions = [25, 50, 100],
}) {
  const styles = useStyles();

  const totalPages = Math.ceil(totalCount / pagination.pageSize) || 1;

  const start =
    totalCount === 0 ? 0 : pagination.pageIndex * pagination.pageSize + 1;

  const end = Math.min(
    (pagination.pageIndex + 1) * pagination.pageSize,
    totalCount,
  );

  return (
    <div className={styles.container}>
      {/* LEFT */}
      <div className={styles.leftSection}>
        <Text className={styles.pageText}>
          Showing {start} - {end} of {totalCount}
        </Text>

        <select
          className={styles.select}
          value={pagination.pageSize}
          onChange={(e) =>
            setPagination((prev) => ({
              ...prev,
              pageSize: Number(e.target.value),
              pageIndex: 0,
            }))
          }
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
      </div>

      {/* RIGHT */}
      <div className={styles.rightSection}>
        <Button
          size="small"
          appearance="subtle"
          icon={<ChevronDoubleLeft16Regular />}
          disabled={!table.getCanPreviousPage()}
          onClick={() => table.setPageIndex(0)}
        />

        <Button
          size="small"
          appearance="subtle"
          icon={<ChevronLeft16Regular />}
          disabled={!table.getCanPreviousPage()}
          onClick={() => table.previousPage()}
        />

        <Text className={styles.pageText}>
          {pagination.pageIndex + 1} / {totalPages}
        </Text>

        <Button
          size="small"
          appearance="subtle"
          icon={<ChevronRight16Regular />}
          disabled={!table.getCanNextPage()}
          onClick={() => table.nextPage()}
        />

        <Button
          size="small"
          appearance="subtle"
          icon={<ChevronDoubleRight16Regular />}
          disabled={!table.getCanNextPage()}
          onClick={() => table.setPageIndex(Math.max(totalPages - 1, 0))}
        />
      </div>
    </div>
  );
}
